import React, { useEffect } from "react";
import {
    Button,
    FormFieldSet,
    Modal,
    useFormHandler,
} from "../../../../../../components";

const StopDeductionModal = ({ open, onClose,row  }) => {
    useEffect(() => {
        if (row) {
          console.log("Received row data:", row);
        }
      }, [row]);
      console.log("Received row data:", row);
    const { formData, errors, handleChange } = useFormHandler({
        stopDate: "",
        comments: "",
    });



    const handleSave = () => {
        const payload = {
            ...formData,
            deductionName: row?.deductionName,
            amount: row?.amount,
            recoveredAmount: row?.recoveredAmount,
        };
        console.log("Stopping deduction with data:", payload);
        onClose();
    };


    return (
        <Modal isOpen={open} onClose={onClose} title="STOP DEDUCTION" width="max-w-5xl">
            <div >
                <div className="grid grid-cols-4 ">
                    <div>
                        <label className="block text-xs font-semibold text-gray-400 mb-1 ">Deduction Name</label>
                        <div className="text-gray-600 text-sm">{row?.deductionName}</div>
                    </div>
                    <div>
                        <label className="block text-xs font-semibold text-gray-400 ml-12 mb-1">Amount</label>
                        <div className="text-gray-600 text-sm ml-12">{row?.amount}</div>
                    </div>
                    <div>
                        <label className="block text-xs  font-semibold text-gray-400 mb-1">Recovered Amount</label>
                        <div className="text-gray-600 text-sm">{row?.recoveredAmount}</div>
                    </div>
                </div>

                <div className="grid grid-cols-2 gap-4 max-w-2xl mt-4">
                <div className="flex flex-col col-span-1 mt-2">
  <FormFieldSet
    type="datepicker"
    title="Stop Date"
    placeholder="MM/DD/YYYY"
    value={formData.stopDate}
    onChange={(value) => handleChange("stopDate", value)}
    error={errors.stopDate}
    showDropdown={false}
  />
    <p className="text-sm text-gray-600 mt-2 whitespace-nowrap overflow-visible text-ellipsis">
      <strong>Note:</strong> You are about to stop deductions with {row?.amount}
    </p>
  </div>
    <FormFieldSet
      type="textArea"
      title="Comments"
      placeholder="Enter any comments"
      value={formData.comments}
      onChange={(value) => handleChange("comments", value)}
      rows={3}
    />
</div>

                <div className="flex justify-end gap-3 pt-4">
                  
                    <Button title="Stop Deduction" onClick={handleSave} className="w-40 h-9" />
                </div>
            </div>
        </Modal>
    );
};

export default StopDeductionModal;
